import useCustomHook from '@/hooks/useCustomHook';

export default function useProgressFeedback({ isStudent }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      progressDetailVisible: false,
    },
    actions: {
      showProgressDetail: (progressDetailVisible) => {
        if (!isStudent) {
          actions.setState({ progressDetailVisible });
        }
      },
    },
  });
  return { state, actions };
}
